import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/metro-runtime';
function resolveWixIamRecoveryV1RecoveryServiceUrl(opts) {
    const domainToMappings = {
        _: [
            {
                srcPath: '/_iam/recovery',
                destPath: '',
            },
            {
                srcPath: '/_api/iam/recovery',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/iam/recovery',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings }));
}
/**
 * Sends a member an email containing a customized link to a Wix-managed page
 * where the member can set a new password for their account.
 */
export function sendRecoveryEmail(payload) {
    function __sendRecoveryEmail({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.recovery.v1.recovery',
            method: 'POST',
            methodFqn: 'wix.iam.recovery.v1.RecoveryService.SendRecoveryEmail',
            url: resolveWixIamRecoveryV1RecoveryServiceUrl({
                protoPath: '/v1/send-email',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __sendRecoveryEmail;
}
/**
 * Sends an activation email with an activation token
 * making the transition from initial contact to a site member
 */
export function sendActivationEmail(payload) {
    function __sendActivationEmail({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.recovery.v1.recovery',
            method: 'POST',
            methodFqn: 'wix.iam.recovery.v1.RecoveryService.SendActivationEmail',
            url: resolveWixIamRecoveryV1RecoveryServiceUrl({
                protoPath: '/v1/activation-email',
                data: payload,
                host,
            }),
            data: payload,
        };
        return metadata;
    }
    return __sendActivationEmail;
}
export function recover(payload) {
    function __recover({ host }) {
        const metadata = {
            entityFqdn: 'wix.iam.recovery.v1.recovery',
            method: 'POST',
            methodFqn: 'wix.iam.recovery.v1.RecoveryService.Recover',
            url: resolveWixIamRecoveryV1RecoveryServiceUrl({
                protoPath: '/v1/recover',
                data: payload,
                host,
            }),
            data: payload,
            transformResponse: (payload) => transformPaths(payload, [
                {
                    transformFn: transformRESTTimestampToSDKTimestamp,
                    paths: [
                        { path: 'identity.createdDate' },
                        { path: 'identity.updatedDate' },
                        { path: 'identity.identityProfile.customFields.value.dateValue' },
                        { path: 'additionalData.dateValue' },
                    ],
                },
                {
                    transformFn: transformRESTFloatToSDKFloat,
                    paths: [
                        { path: 'identity.identityProfile.customFields.value.numValue' },
                        { path: 'additionalData.numValue' },
                    ],
                },
            ]),
        };
        return metadata;
    }
    return __recover;
}
//# sourceMappingURL=iam-recovery-v1-recovery-recovery.http.js.map